export const getFeatureFlag = async (flagName) => {
    if (flagName === 'ai-prequal') {
        return false;
    }
    return false;
};

export default {
    get: getFeatureFlag,
};